"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFeature = exports.checkChainFeatures = exports.NonRecognizableChainFeatures = exports.RecognizableChainFeatures = exports.RecognizableChainFeaturesMethod = exports.SupportedChainFeatures = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Indicate the features which keplr supports.
 */
exports.SupportedChainFeatures = [
    "stargate",
    "cosmwasm",
    "wasmd_0.24+",
    "secretwasm",
    "ibc-transfer",
    "no-legacy-stdTx",
    "ibc-go",
    "eth-address-gen",
    "eth-key-sign",
    "query:/cosmos/bank/v1beta1/spendable_balances",
    "axelar-evm-bridge",
    "osmosis-txfees",
];
/**
 * Describe the way to know whether that feature is needed.
 * This is used in `checkChainFeatures` function.
 * `checkChainFeatures` function iterate this constant
 * and execute method in sequence
 * and if it returns "true", it pushes that feature and deliver it to next method.
 * So, the order is important.
 */
exports.RecognizableChainFeaturesMethod = [
    {
        feature: "ibc-go",
        fetch: (_features, _rpcInstance, restInstance) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield restInstance.get("/ibc/apps/transfer/v1/params", {
                validateStatus: (status) => {
                    return status === 200 || status === 501;
                },
            });
            return response.status === 200;
        }),
    },
    {
        feature: "ibc-transfer",
        fetch: (features, _rpcInstance, restInstance) => __awaiter(void 0, void 0, void 0, function* () {
            const requestUrl = features.includes("ibc-go")
                ? "/ibc/apps/transfer/v1/params"
                : "/ibc/applications/transfer/v1beta1/params";
            const result = yield restInstance.get(requestUrl, {
                validateStatus: (status) => {
                    return status === 200 || status === 501;
                },
            });
            return (result.status === 200 &&
                result.data.params.receive_enabled &&
                result.data.params.send_enabled);
        }),
    },
    {
        feature: "wasmd_0.24+",
        fetch: (features, _rpcInstance, restInstance) => __awaiter(void 0, void 0, void 0, function* () {
            if (features.includes("cosmwasm")) {
                const result = yield restInstance.get("/cosmwasm/wasm/v1/contract/test/smart/test", {
                    validateStatus: (status) => {
                        return status === 400 || status === 501;
                    },
                });
                if (result.status === 400) {
                    return true;
                }
            }
            return false;
        }),
    },
    {
        feature: "query:/cosmos/bank/v1beta1/spendable_balances",
        fetch: (_features, _rpcInstance, restInstance) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield restInstance.get("/cosmos/bank/v1beta1/spendable_balances/test", {
                validateStatus: (status) => {
                    return status === 400 || status === 501;
                },
            });
            return result.status === 400;
        }),
    },
];
/**
 * Indicate the features which keplr can know whether that feature is needed.
 */
exports.RecognizableChainFeatures = exports.RecognizableChainFeaturesMethod.map((method) => method.feature);
exports.NonRecognizableChainFeatures = (() => {
    const m = {};
    for (const feature of exports.RecognizableChainFeatures) {
        m[feature] = true;
    }
    const r = [];
    for (const feature of exports.SupportedChainFeatures) {
        if (!m[feature]) {
            r.push(feature);
        }
    }
    return r;
})();
/**
 * Returns features that chain will have to update
 * @param chainInfo
 */
function checkChainFeatures(chainInfo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const newFeatures = [];
        const features = (_b = (_a = chainInfo.features) === null || _a === void 0 ? void 0 : _a.slice()) !== null && _b !== void 0 ? _b : [];
        const rpcInstance = axios_1.default.create({
            baseURL: chainInfo.rpc,
        });
        const restInstance = axios_1.default.create({
            baseURL: chainInfo.rest,
        });
        for (const method of exports.RecognizableChainFeaturesMethod) {
            if (features.includes(method.feature)) {
                continue;
            }
            try {
                if (yield method.fetch(features, rpcInstance, restInstance)) {
                    newFeatures.push(method.feature);
                    features.push(method.feature);
                }
            }
            catch (e) {
                console.log(`Failed to try to fetch feature (${method.feature}): ${e.message || e}`);
            }
        }
        return newFeatures;
    });
}
exports.checkChainFeatures = checkChainFeatures;
function hasFeature(chainInfo, feature) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        if ((_a = chainInfo.features) === null || _a === void 0 ? void 0 : _a.includes(feature)) {
            return true;
        }
        const method = exports.RecognizableChainFeaturesMethod.find((m) => m.feature === feature);
        if (!method) {
            throw new Error(`${feature} not exist on RecognizableChainFeaturesMethod`);
        }
        const rpcInstance = axios_1.default.create({
            baseURL: chainInfo.rpc,
        });
        const restInstance = axios_1.default.create({
            baseURL: chainInfo.rest,
        });
        return method.fetch((_c = (_b = chainInfo.features) === null || _b === void 0 ? void 0 : _b.slice()) !== null && _c !== void 0 ? _c : [], rpcInstance, restInstance);
    });
}
exports.hasFeature = hasFeature;
//# sourceMappingURL=feature.js.map